import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useState } from "react";
import { useIntl } from "react-intl";
import Button from "@overrides_venia/venia-ui/components/Button";
import { format, getDaysInMonth, isValid, parse } from "date-fns";
import { LabeledPicker } from "@Components/LabeledPicker/labeledPicker";
import Modal from "@Components/Modal";
import it from "date-fns/locale/it";
import { SimpleField } from "@Components/FormFields/SimpleField";
import { useWindowSize } from "@overrides_venia/peregrine/hooks/useWindowSize";
const DobField = _ref => {
  let {
    value,
    setValue,
    showLabel,
    required = false,
    borderClass,
    showInvalid,
    backgroundClass = 'uk-background-creamer',
    note
  } = _ref;
  const {
    isMobile
  } = useWindowSize();
  const {
    formatMessage
  } = useIntl();
  const [isModalDobPickerOpen, setIsModalDobPickerOpen] = useState(false);
  const initialDate = value ? value.split("-").reverse() : ["01", "01", "2000"];
  const [pickerValue, setPickerValue] = useState({
    day: initialDate[0],
    month: initialDate[1],
    year: initialDate[2]
  });
  const dobStyle = value ? {
    height: "48px",
    padding: "0 16px"
  } : {
    height: "48px",
    padding: "0 16px",
    fontSize: "14px"
  };
  const days = Array.from({
    length: 31
  }, (_, i) => i + 1).map(day => {
    return {
      value: day.toString().padStart(2, "0"),
      label: day.toString()
    };
  });
  const months = Array.from({
    length: 12
  }, (_, i) => new Date(0, i)).map(date => format(date, "MMMM", {
    locale: it
  })).map((month, i) => {
    return {
      value: (i + 1).toString().padStart(2, "0"),
      label: formatMessage({
        id: month
      })
    };
  });
  const years = Array.from({
    length: 100
  }, (_, i) => i + 1920).reverse().map(year => {
    return {
      value: year.toString(),
      label: year.toString()
    };
  });
  const [dateOptionGroups, setDateTimeOptionGroups] = useState({
    day: days,
    month: months,
    year: years
  });
  const handleSetDob = value => {
    const newDate = _objectSpread(_objectSpread({}, pickerValue), value);
    const year = parseInt(newDate.year, 10);
    const month = parseInt(newDate.month, 10) - 1;
    const day = parseInt(newDate.day, 10);
    const newConstructedDate = new Date(year, month, day);
    const shouldRecalculateDaysOptions = !isValid(new Date(newConstructedDate)) || !(newConstructedDate.getFullYear() === year && newConstructedDate.getMonth() === month && newConstructedDate.getDate() === day);
    const dummyParsedDate = new Date(newDate.year, newDate.month - 1, "01");
    const daysInMonth = getDaysInMonth(shouldRecalculateDaysOptions ? dummyParsedDate : newConstructedDate);
    const newDays = Array.from({
      length: daysInMonth
    }, (_, i) => i + 1).map(day => {
      return {
        value: day.toString().padStart(2, "0"),
        label: day.toString()
      };
    });
    setDateTimeOptionGroups(prevOptions => _objectSpread(_objectSpread({}, prevOptions), {}, {
      day: newDays
    }));
    if (!shouldRecalculateDaysOptions) {
      setPickerValue(value);
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SimpleField, {
    value: value,
    showLabel: showLabel,
    label: "birthday",
    backgroundClass: backgroundClass,
    borderClass: borderClass,
    note: note,
    name: "dob",
    onClick: () => setIsModalDobPickerOpen(true),
    required: required,
    showInvalid: showInvalid,
    children: /*#__PURE__*/React.createElement("div", {
      className: "uk-flex uk-flex-column uk-flex-center section-full-rounded",
      style: dobStyle
    }, value ? format(parse(value, "yyyy-MM-dd", new Date()), "d MMMM yyyy", {
      locale: it
    }) : formatMessage({
      id: "input.birthday"
    }))
  }), /*#__PURE__*/React.createElement(Modal, {
    id: "modal-dob-selection",
    nameClass: "modal-dob-selection",
    position: "uk-position-fixed ".concat(isMobile ? "uk-position-bottom" : "uk-position-center"),
    modalDialogClass: "".concat(isMobile ? "section-rounded" : "uk-border-rounded", "  uk-modal-body"),
    animation: "".concat(isMobile ? "uk-animation-slide-bottom" : "uk-animation-scale-up"),
    modalCloseOutside: true,
    isOpen: isModalDobPickerOpen,
    onClose: () => setIsModalDobPickerOpen(false)
  }, /*#__PURE__*/React.createElement(LabeledPicker, {
    labeledOptionGroups: dateOptionGroups,
    pickerValue: pickerValue,
    setPickerValue: handleSetDob
  }), /*#__PURE__*/React.createElement(Button, {
    id: "editDobConfirm",
    color: "miscusi_red",
    fullScreen: true,
    onClick: () => {
      setIsModalDobPickerOpen(false);
      if (setValue) {
        setValue("".concat(pickerValue.year, "-").concat(pickerValue.month, "-").concat(pickerValue.day));
      }
    }
  }, /*#__PURE__*/React.createElement("span", null, formatMessage({
    id: "button.confirm"
  })))));
};
export default DobField;